import { render, staticRenderFns } from "./templates-dynamic-switch.vue?vue&type=template&id=ef8a1d68&scoped=true&lang=pug"
import script from "./templates-dynamic-switch.vue?vue&type=script&lang=js"
export * from "./templates-dynamic-switch.vue?vue&type=script&lang=js"
import style0 from "./templates-dynamic-switch.vue?vue&type=style&index=0&id=ef8a1d68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8a1d68",
  null
  
)

export default component.exports